(() => {
  const button = document.querySelector('[data-cookie-preferences]');
  const status = document.getElementById('cookie-preferences-status');

  if (!button || !status) return;

  const waitFor = (readValue, timeout = 5000) => new Promise((resolve, reject) => {
    const startedAt = Date.now();
    const check = () => {
      const value = readValue();
      if (value) return resolve(value);
      if (Date.now() - startedAt >= timeout) return reject(new Error('Shopify privacy API unavailable'));
      window.setTimeout(check, 50);
    };
    check();
  });

  const loadCustomerPrivacy = async () => {
    const loadFeatures = await waitFor(() => window.Shopify && window.Shopify.loadFeatures);
    await new Promise((resolve, reject) => {
      loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        error => error ? reject(error) : resolve()
      );
    });
    return waitFor(() => window.Shopify && window.Shopify.customerPrivacy);
  };

  button.addEventListener('click', async () => {
    button.disabled = true;
    status.textContent = 'Ouverture des préférences de cookies…';

    try {
      await loadCustomerPrivacy();
      const banner = await waitFor(() => window.privacyBanner);
      await banner.showPreferences();
      status.textContent = 'Préférences de cookies ouvertes.';
    } catch (error) {
      status.textContent = 'Impossible d’ouvrir les préférences de cookies. Veuillez réessayer.';
      console.error('Cookie preferences could not be opened.', error);
    } finally {
      button.disabled = false;
    }
  });
})();
